import Vue from 'vue'
import Vuex from 'vuex'

import VuexPersistence from 'vuex-persist'
import locale from './modules/locale.module'
import sales from './modules/sales.module'

Vue.use(Vuex)

const vuexLocal = new VuexPersistence({
  storage: window.localStorage,
  reducer: (state) => ({ locale: state.locale }), // save only locale module
})

const store = new Vuex.Store({
  modules: {
    locale,
    sales,
  },
  plugins: [vuexLocal.plugin],
})

export default store
